/** Firestore search helpers persisted on product documents. */

type SearchableProduct = {
  name: string
  category: string
}

function tokenize(text: string, tokens: Set<string>) {
  const lower = text.toLowerCase().trim()
  if (!lower) return
  tokens.add(lower)
  for (const word of lower.split(/[^a-z0-9]+/)) {
    if (word.length >= 2) tokens.add(word)
  }
}

export function buildProductSearchFields(product: SearchableProduct) {
  const tokens = new Set<string>()
  tokenize(product.name, tokens)
  tokenize(product.category, tokens)

  return {
    nameLower: product.name.toLowerCase().trim(),
    searchTokens: Array.from(tokens).slice(0, 150),
  }
}

export function parseSearchQuery(q: string): string[] {
  return q
    .toLowerCase()
    .trim()
    .split(/[^a-z0-9]+/)
    .filter((word) => word.length >= 2)
}

/** Match product name and category against all search tokens (substring, case-insensitive). */
export function productMatchesSearchTokens(
  product: SearchableProduct,
  tokens: string[]
): boolean {
  if (tokens.length === 0) return false
  const haystack = [product.name, product.category].join(' ').toLowerCase()
  return tokens.every((token) => haystack.includes(token))
}
